"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrying = void 0;
const _1 = require(".");
const expontentialWithJitter = (attempt) => {
    const base = 500;
    const max = 10000;
    const jitter = 0.5;
    const exponentialDelay = base * 2 ** attempt;
    const cappedDelay = Math.min(exponentialDelay, max);
    const jitterRange = cappedDelay * jitter;
    const jitterAmount = Math.random() * jitterRange;
    return cappedDelay - jitterAmount;
};
const retrying = (fn, options = {
    maxAttempts: 3,
    backoffFn: expontentialWithJitter,
}) => {
    const baseOptions = Object.assign({ maxAttempts: 3, backoffFn: expontentialWithJitter, lastAttemptFn: fn }, options);
    const runner = (count, ...args) => {
        const run = count === baseOptions.maxAttempts ? baseOptions.lastAttemptFn : fn;
        return run(...args).catch((err) => {
            if (count < baseOptions.maxAttempts) {
                const delay = baseOptions.backoffFn(count - 1);
                return (0, _1.wait)(delay).then(() => runner(count + 1, ...args));
            }
            throw err;
        });
    };
    return (...args) => runner(1, ...args);
};
exports.retrying = retrying;
//# sourceMappingURL=retry.js.map